import { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import { get, isEmpty, find } from 'lodash';

import config from '../../../config';

const useSolicitudData = token => {
  const [notFound, setNotFound] = useState('');
  const [loading, setLoading] = useState(true);
  const [alreadyUsed, setAlreadyUsed] = useState('');
  const [distribuidora, setDistribuidora] = useState({});
  const [tipoCambio, setTipoCambio] = useState('');

  const [tokenNubarium, setTokenNubarium] = useState();
  const [ineFrontUrl, setIneFrontUrl] = useState(null);
  const [ineBackUrl, setIneBackUrl] = useState(null);

  const [segurosDistribuidoras, setSegurosDistribuidoras] = useState([]);
  const [bancos, setBancos] = useState([]);

  const [
    nombreCompletoDistribuidora,
    setNombreCompletoDistribuidora,
  ] = useState('');
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [identityValidationAttempts, setIdentityValidationAttempts] = useState(
    0,
  );

  const fetchConfig = async () => {
    try {
      const response = await Axios.get(`${config.api.url}/configuraciones`);
      setTermsAndConditions(get(response, 'data[0].terminosCondiciones', ''));
      setIdentityValidationAttempts(
        get(response, 'data[0].intentosValidacionIdentidad', ''),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await Axios.get(
        `${config.api.url}/distribuidoras/solicitud-cambio`,
        {
          params: {
            token,
          },
        },
      );

      const tipoCambioSDC =
        response.data.solicitudCambioDistribuidora.tipoCambio;

      if (tipoCambioSDC === 'tarjeta') {
        const responseBancos = await Axios.get(`${config.api.url}/bancos`, {
          params: {
            filter: {
              where: {
                estatus: 'activo',
                nombre: { nin: ['STP', 'TARJETA DE CORAZÓN'] },
              },
            },
          },
        });

        setBancos(responseBancos.data);
      } else if (tipoCambioSDC === 'seguro') {
        const responseSeguros = await Axios.get(
          `${config.api.url}/distribuidoras/seguros-distribuidoras`,
        );

        setSegurosDistribuidoras(responseSeguros.data);
      }

      setTokenNubarium(response.data.tokenNubarium);
      setNombreCompletoDistribuidora(
        response.data.solicitudCambioDistribuidora.nombreCompletoDistribuidora,
      );
      setTipoCambio(
        get(response, 'data.solicitudCambioDistribuidora.tipoCambio', ''),
      );

      if (!isEmpty(response.data.identificacion)) {
        setIneFrontUrl(
          find(response.data.identificacion, {
            tipo: 'credencialElectorSuperior',
          }).url,
        );

        setIneBackUrl(
          find(response.data.identificacion, {
            tipo: 'credencialElectorInferior',
          }).url,
        );
      }

      if (!get(response, 'data')) {
        setNotFound(true);
      }

      const solicitudStatus = get(
        response,
        'data.solicitudCambioDistribuidora.estatus',
        '',
      );

      if (solicitudStatus !== 'pendiente') {
        if (
          solicitudStatus === 'cancelado' ||
          solicitudStatus === 'bloqueado'
        ) {
          setAlreadyUsed('Esta solicitud de cambio se encuentra cancelada');
        } else if (solicitudStatus === 'confirmado') {
          setAlreadyUsed('Esta solicitud de cambio ya fue procesada.');
        } else {
          setAlreadyUsed(
            'No se encuentra información de la solicitud de cambio.',
          );
        }
      }
    } catch (error) {
      setNotFound(true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchConfig();
  }, []);

  return {
    loading,
    notFound,
    alreadyUsed,
    distribuidora,
    tipoCambio,
    tokenNubarium,
    ineFrontUrl,
    ineBackUrl,
    termsAndConditions,
    identityValidationAttempts,
    nombreCompletoDistribuidora,
    bancos,
    segurosDistribuidoras,
  };
};

export default useSolicitudData;
